import { SKINS } from 'constants/skins'
import { PAGE_CONTENT } from 'constants/PageContent/PageContent'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { icons, logos } from 'common'

import { AnnouncementLeftPanelSection } from 'components/pages/gamesV3/Announcements.leftPanelSection'
import { HiLoSideGame } from '../SideGames/HiLoSideGame'

export const PANEL_SECTIONS = [
  {
    contentType: null,
    defaultOpen: true,
    showWithSkin: SKINS.DEFAULT,
    icon: { path: icons.events_icon_white, color: '#fff', masked: false },
    title: 'ANNOUNCEMENTS',
    content: <AnnouncementLeftPanelSection />,
  },
  {
    contentType: null,
    defaultOpen: false,
    showWithSkin: null,
    icon: { path: logos.yolo_hilo_icon, color: '#2159d1', masked: false },
    title: 'Hi-Lo',
    content: <HiLoSideGame />,
  },

  {
    contentType: CONTENT_TYPES.LVG_AI_INDEXES,
    defaultOpen: false,
    showWithSkin: null,
    icon: {
      path: PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].icon,
      color: PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].color,
      masked: PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].maskedIcon,
      size: PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].iconSize,
    },
    title: (
      <>
        {PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].title}{' '}
        <div
          className='beta_icon-ai_indexes'
          style={{ background: `${PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].color}` }}
        />
      </>
    ),
    content: PAGE_CONTENT[CONTENT_TYPES.LVG_AI_INDEXES].content,
  },
  {
    contentType: CONTENT_TYPES.LVG_INDEXES,
    defaultOpen: false,
    showWithSkin: null,
    icon: {
      path: PAGE_CONTENT[CONTENT_TYPES.LVG_INDEXES].icon,
      color: PAGE_CONTENT[CONTENT_TYPES.LVG_INDEXES].color,
      masked: PAGE_CONTENT[CONTENT_TYPES.LVG_INDEXES].maskedIcon,
    },
    title: PAGE_CONTENT[CONTENT_TYPES.LVG_INDEXES].title,
    content: PAGE_CONTENT[CONTENT_TYPES.LVG_INDEXES].content,
  },
  // {
  //   contentType: CONTENT_TYPES.LVG_STOCKS,
  //   defaultOpen: false,
  //   showWithSkin: null,
  //   icon: {
  //     path: PAGE_CONTENT[CONTENT_TYPES.LVG_STOCKS].icon,
  //     color: PAGE_CONTENT[CONTENT_TYPES.LVG_STOCKS].color,
  //     masked: PAGE_CONTENT[CONTENT_TYPES.LVG_STOCKS].maskedIcon,
  //   },
  //   title: PAGE_CONTENT[CONTENT_TYPES.LVG_STOCKS].title,
  //   content: PAGE_CONTENT[CONTENT_TYPES.LVG_STOCKS].content,
  // },
  {
    contentType: CONTENT_TYPES.LVG_CRYPTO,
    defaultOpen: false,
    showWithSkin: null,
    icon: {
      path: PAGE_CONTENT[CONTENT_TYPES.LVG_CRYPTO].icon,
      color: PAGE_CONTENT[CONTENT_TYPES.LVG_CRYPTO].color,
      masked: PAGE_CONTENT[CONTENT_TYPES.LVG_CRYPTO].maskedIcon,
    },
    title: PAGE_CONTENT[CONTENT_TYPES.LVG_CRYPTO].title,
    content: PAGE_CONTENT[CONTENT_TYPES.LVG_CRYPTO].content,
  },
  // {
  //   contentType: CONTENT_TYPES.G_BUSTED,
  //   defaultOpen: false,
  //   showWithSkin: null,
  //   icon: {
  //     path: PAGE_CONTENT[CONTENT_TYPES.G_BUSTED].icon,
  //     color: PAGE_CONTENT[CONTENT_TYPES.G_BUSTED].color,
  //     masked: PAGE_CONTENT[CONTENT_TYPES.G_BUSTED].maskedIcon,
  //   },
  //   title: PAGE_CONTENT[CONTENT_TYPES.G_BUSTED].title,
  //   content: PAGE_CONTENT[CONTENT_TYPES.G_BUSTED].content,
  // },
]
